// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function fare_amount_encode(v) {
  return Js_dict.fromArray([
              [
                "currency",
                Decco.stringToJson(v.currency)
              ],
              [
                "minor_amount",
                Decco.intToJson(v.minor_amount)
              ]
            ]);
}

function fare_amount_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var currency = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "currency"), null));
  if (currency.TAG === /* Ok */0) {
    var minor_amount = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "minor_amount"), null));
    if (minor_amount.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                currency: currency._0,
                minor_amount: minor_amount._0
              }
            };
    }
    var e = minor_amount._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".minor_amount" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = currency._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".currency" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function free_distance_pricing_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var free_kms = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "free_kms"), null));
  if (free_kms.TAG === /* Ok */0) {
    var price_per_min = fare_amount_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "price_per_min"), null));
    if (price_per_min.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                free_kms: free_kms._0,
                price_per_min: price_per_min._0
              }
            };
    }
    var e = price_per_min._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".price_per_min" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = free_kms._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".free_kms" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function slab_encode(v) {
  return Js_dict.fromArray([
              [
                "slab_km",
                Decco.intToJson(v.slab_km)
              ],
              [
                "price_per_min",
                fare_amount_encode(v.price_per_min)
              ],
              [
                "price_per_km",
                fare_amount_encode(v.price_per_km)
              ]
            ]);
}

function slab_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var slab_km = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "slab_km"), null));
  if (slab_km.TAG === /* Ok */0) {
    var price_per_min = fare_amount_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "price_per_min"), null));
    if (price_per_min.TAG === /* Ok */0) {
      var price_per_km = fare_amount_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "price_per_km"), null));
      if (price_per_km.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  slab_km: slab_km._0,
                  price_per_min: price_per_min._0,
                  price_per_km: price_per_km._0
                }
              };
      }
      var e = price_per_km._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".price_per_km" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = price_per_min._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".price_per_min" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = slab_km._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".slab_km" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function core_pricing_structure_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var base_fare = fare_amount_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "base_fare"), null));
  if (base_fare.TAG === /* Ok */0) {
    var free_duration = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "free_duration"), null));
    if (free_duration.TAG === /* Ok */0) {
      var waiting_rate_per_min = fare_amount_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "waiting_rate_per_min"), null));
      if (waiting_rate_per_min.TAG === /* Ok */0) {
        var free_distance_pricing = free_distance_pricing_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "free_distance_pricing"), null));
        if (free_distance_pricing.TAG === /* Ok */0) {
          var distance_time_pricing = Decco.listFromJson(slab_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "distance_time_pricing"), null));
          if (distance_time_pricing.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      base_fare: base_fare._0,
                      free_duration: free_duration._0,
                      waiting_rate_per_min: waiting_rate_per_min._0,
                      free_distance_pricing: free_distance_pricing._0,
                      distance_time_pricing: distance_time_pricing._0
                    }
                  };
          }
          var e = distance_time_pricing._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".distance_time_pricing" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = free_distance_pricing._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".free_distance_pricing" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = waiting_rate_per_min._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".waiting_rate_per_min" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = free_duration._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".free_duration" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = base_fare._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".base_fare" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function creator_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var first_name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "first_name"), null));
  if (first_name.TAG === /* Ok */0) {
    var last_name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "last_name"), null));
    if (last_name.TAG === /* Ok */0) {
      var email = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "email"), null));
      if (email.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  first_name: first_name._0,
                  last_name: last_name._0,
                  email: email._0
                }
              };
      }
      var e = email._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".email" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = last_name._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".last_name" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = first_name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".first_name" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function creation_info_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var creator = creator_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "creator"), null));
  if (creator.TAG === /* Ok */0) {
    var creation_time = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "creation_time"), null));
    if (creation_time.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                creator: creator._0,
                creation_time: creation_time._0
              }
            };
    }
    var e = creation_time._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".creation_time" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = creator._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".creator" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function approver_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var first_name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "first_name"), null));
  if (first_name.TAG === /* Ok */0) {
    var last_name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "last_name"), null));
    if (last_name.TAG === /* Ok */0) {
      var email = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "email"), null));
      if (email.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  first_name: first_name._0,
                  last_name: last_name._0,
                  email: email._0
                }
              };
      }
      var e = email._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".email" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = last_name._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".last_name" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = first_name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".first_name" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function status_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var campaign_status = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "campaign_status"), null));
  if (campaign_status.TAG === /* Ok */0) {
    var approval_time = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "approval_time"), null));
    if (approval_time.TAG === /* Ok */0) {
      var approver = Decco.optionFromJson(approver_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "approver"), null));
      if (approver.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  campaign_status: campaign_status._0,
                  approval_time: approval_time._0,
                  approver: approver._0
                }
              };
      }
      var e = approver._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".approver" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = approval_time._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".approval_time" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = campaign_status._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".campaign_status" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function campaign_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
  if (name.TAG === /* Ok */0) {
    var external_id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "external_id"), null));
    if (external_id.TAG === /* Ok */0) {
      var status = status_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "status"), null));
      if (status.TAG === /* Ok */0) {
        var geo_region_id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "geo_region_id"), null));
        if (geo_region_id.TAG === /* Ok */0) {
          var vehicle_id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "vehicle_id"), null));
          if (vehicle_id.TAG === /* Ok */0) {
            var start_instant = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "start_instant"), null));
            if (start_instant.TAG === /* Ok */0) {
              var end_instant = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "end_instant"), null));
              if (end_instant.TAG === /* Ok */0) {
                var core_pricing_structure = core_pricing_structure_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "core_pricing_structure"), null));
                if (core_pricing_structure.TAG === /* Ok */0) {
                  var creation_info = creation_info_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "creation_info"), null));
                  if (creation_info.TAG === /* Ok */0) {
                    return {
                            TAG: /* Ok */0,
                            _0: {
                              name: name._0,
                              external_id: external_id._0,
                              status: status._0,
                              geo_region_id: geo_region_id._0,
                              vehicle_id: vehicle_id._0,
                              start_instant: start_instant._0,
                              end_instant: end_instant._0,
                              core_pricing_structure: core_pricing_structure._0,
                              creation_info: creation_info._0
                            }
                          };
                  }
                  var e = creation_info._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".creation_info" + e.path,
                            message: e.message,
                            value: e.value
                          }
                        };
                }
                var e$1 = core_pricing_structure._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".core_pricing_structure" + e$1.path,
                          message: e$1.message,
                          value: e$1.value
                        }
                      };
              }
              var e$2 = end_instant._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".end_instant" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                      }
                    };
            }
            var e$3 = start_instant._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".start_instant" + e$3.path,
                      message: e$3.message,
                      value: e$3.value
                    }
                  };
          }
          var e$4 = vehicle_id._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".vehicle_id" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
        }
        var e$5 = geo_region_id._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".geo_region_id" + e$5.path,
                  message: e$5.message,
                  value: e$5.value
                }
              };
      }
      var e$6 = status._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".status" + e$6.path,
                message: e$6.message,
                value: e$6.value
              }
            };
    }
    var e$7 = external_id._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".external_id" + e$7.path,
              message: e$7.message,
              value: e$7.value
            }
          };
  }
  var e$8 = name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".name" + e$8.path,
            message: e$8.message,
            value: e$8.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var campaigns = Decco.listFromJson(campaign_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "campaigns"), null));
  if (campaigns.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              campaigns: campaigns._0
            }
          };
  }
  var e = campaigns._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".campaigns" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

export {
  fare_amount_encode ,
  fare_amount_decode ,
  free_distance_pricing_decode ,
  slab_encode ,
  slab_decode ,
  core_pricing_structure_decode ,
  creator_decode ,
  creation_info_decode ,
  approver_decode ,
  status_decode ,
  campaign_decode ,
  t_decode ,
  
}
/* No side effect */
